import createUploaderComponent from '../../utils/create-uploader-component.js'
import xhrUploaderPlugin from './xhr-uploader-plugin.js'

export default createUploaderComponent(xhrUploaderPlugin)
